import { jsx as o } from "react/jsx-runtime";
import { Alert as i } from "@chakra-ui/react";
import { AlertDescription as s, AlertTitle as A } from "@chakra-ui/react";
const p = ({ children: r, status: t, ...e }) => /* @__PURE__ */ o(i, { ...e, status: t, padding: 4, borderRadius: "md", fontSize: 14, children: r });
export {
  p as Alert,
  s as AlertDescription,
  A as AlertTitle
};
//# sourceMappingURL=index.es.js.map
